module.exports = __webpack_public_path__ + "img/app_qrcode.b40ed443.jpg";